(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('fixed-top');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('searchModal');     
    }
  }

  customElements.define('sticky-header', StickyHeader);




  
 wdtHeaderMenu = document.querySelector('.dt-desktop-menu');
let wdtDeviceWidth = window.innerWidth;

if (wdtHeaderMenu && wdtDeviceWidth > 1199) {

  /* ----------------------
     PARENT LEVEL DROPDOWN
  -----------------------*/
  wdtHeaderMenu.querySelectorAll('li.nav-item').forEach(function (item) {

    var link = item.querySelector('.nav-link.dropdown-toggle');
    var menu = item.querySelector('.dropdown-menu');

    if (!link || !menu) return;

    let closeTimer;

    function openParent() {
      clearTimeout(closeTimer);
      menu.setAttribute('data-bs-popper', 'static');
      link.classList.add('show');
      menu.classList.add('show');
    }

    function closeParent() {
      closeTimer = setTimeout(function () {
        link.classList.remove('show');
        menu.classList.remove('show');
      }, 250);
    }

    link.addEventListener('mouseenter', openParent);
    link.addEventListener('mouseleave', closeParent);

    menu.addEventListener('mouseenter', openParent);
    menu.addEventListener('mouseleave', closeParent);

    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = link.href;
    });
  });

  /* ----------------------
     CHILD LEVEL DROPDOWN
  -----------------------*/
  wdtHeaderMenu.querySelectorAll('.dropdown-item').forEach(function (child) {

    var childMenu = child.nextElementSibling;

    if (!childMenu || !childMenu.classList.contains('dropdown-menu')) return;

    let childTimer;

    function openChild() {
      clearTimeout(childTimer);
      child.classList.add('show');
      childMenu.classList.add('show');
    }

    function closeChild() {
      childTimer = setTimeout(function () {
        child.classList.remove('show');
        childMenu.classList.remove('show');
      }, 250);
    }

    child.addEventListener('mouseenter', openChild);
    child.addEventListener('mouseleave', closeChild);

    childMenu.addEventListener('mouseenter', openChild);
    childMenu.addEventListener('mouseleave', closeChild);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-skin-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('fixed-top');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.header) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  function initSkinHeaderDropdowns(menuRoot) {
    if (!menuRoot) return;
    if (window.getComputedStyle(menuRoot).display === 'none') return;

    menuRoot.querySelectorAll('li.nav-item').forEach(function (item) {
      var link = item.querySelector('.nav-link.dropdown-toggle');
      var megaPanel = item.querySelector('.mega-menu__content');
      var menu = megaPanel || item.querySelector('.dropdown-menu');
      if (!link || !menu) return;

      var closeTimer;

      function openParent() {
        clearTimeout(closeTimer);
        menu.setAttribute('data-bs-popper', 'static');
        link.classList.add('show');
        menu.classList.add('show');
        link.setAttribute('aria-expanded', 'true');
      }

      function closeParent() {
        closeTimer = setTimeout(function () {
          link.classList.remove('show');
          menu.classList.remove('show');
          link.setAttribute('aria-expanded', 'false');
        }, 250);
      }

      link.addEventListener('mouseenter', openParent);
      link.addEventListener('mouseleave', closeParent);
      menu.addEventListener('mouseenter', openParent);
      menu.addEventListener('mouseleave', closeParent);

      link.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = link.href;
      });
    });

    menuRoot.querySelectorAll('.dropdown-item.dropdown-toggle').forEach(function (child) {
      var childMenu = child.nextElementSibling;
      if (!childMenu || !childMenu.classList.contains('dropdown-menu')) return;

      var childTimer;

      function openChild() {
        clearTimeout(childTimer);
        child.classList.add('show');
        childMenu.classList.add('show');
        child.setAttribute('aria-expanded', 'true');
      }

      function closeChild() {
        childTimer = setTimeout(function () {
          child.classList.remove('show');
          childMenu.classList.remove('show');
          child.setAttribute('aria-expanded', 'false');
        }, 250);
      }

      child.addEventListener('mouseenter', openChild);
      child.addEventListener('mouseleave', closeChild);
      childMenu.addEventListener('mouseenter', openChild);
      childMenu.addEventListener('mouseleave', closeChild);
    });
  }

  function initAllSkinHeaderDropdowns() {
    if (window.innerWidth < 992) return;
    document.querySelectorAll('.skin-header .dt-desktop-menu').forEach(initSkinHeaderDropdowns);
  }

  initAllSkinHeaderDropdowns();

  } catch(e) { console.error(e); }
})();
})();
